import { ReactNode, useReducer } from 'react';
import { UserStateContext, UserDispatchContext } from './userContext';
import { userReducer } from './user.reducer';
import { User } from '@insync-students-lib/models';
import { Token } from '@insync-students-lib/models/token';
import { SchoolClass } from '@insync-students-lib/models/schoolClass/schoolClass.model';
export interface IUserState {
  user: User;
  token: Token;
  products: string[];
  curricula: string[];
  classes: SchoolClass[];
  schoolYear?: string;
}
interface Iface {
  children?: ReactNode;
  schoolYear?: string;
}

/**
 * UserProvider
 * @param {Object}    children    - Component on which the provider data will be available
 */

export function UserProvider({
  children,
  schoolYear
}: Iface) {
  const [state, dispatchUser] = useReducer(userReducer, {
    user: new User({}),
    token: new Token({}),
    products: [],
    classes: [],
    curricula: [],
    schoolYear
  });
  return <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatchUser}>{children}</UserDispatchContext.Provider>
    </UserStateContext.Provider>;
}